import React, { memo } from 'react';
import Slider from "rc-slider";
import { useDebounceCallback } from 'usehooks-ts'
import 'rc-slider/assets/index.css';

const marks = { 5: '5', 6: '6', 7: '7', 8: '8', 9: '9', 10: '10', 11: '11', 12: '12', 13: '13', 14: '14', 15: '15' }
const AgeSlider = ({ minimum_age = 5, maximum_age = 15, onChange = () => {} }) => {
  const debounced = useDebounceCallback(onChange, 200)
  return (
    <div className="exerciseCollection-form-year_span">
      <Slider
        min={5}
        max={15}
        step={1}
        marks={marks}
        range
        defaultValue={[5, 15]}
        value={[minimum_age, maximum_age]}
        onChange={(([minimum_age, maximum_age]) => debounced({ minimum_age, maximum_age })
        )}
      />
    </div>
  );
};

export default memo(AgeSlider);


